import React, { Component } from 'react';
import { connect } from "react-redux";
import CustomTable from "../../utils/commonComponent/CustomAntTable";
import { ComponentHeader, InformationModal, VerifiedModal } from '../common';
import editIcon from '../../assets/images/edit-icon.svg'
import deleteIcon from '../../assets/images/delete-icon.svg'
import { Button, Col, Image, Row } from "react-bootstrap";
import { MODULE_ID_MAP, START_PAGE, isModuleExist } from "../../utils/Constant";
import editPencil from "../../assets/images/edit-icon.png";
import { TEMPLATE_CONTENT_VERIFY, TEMPLATE_VERIFY } from '../../utils/urls';
import FilterVefiedDropDown from '../common/FilterVefiedDropDown';
import { deleteAuthCommonApi } from "../content/Api";
import { toast } from 'react-toastify';
import { getAllCustomTemplatesApi } from './Api';
import { replaceHistory } from '../../utils/ReusableFunctions';
import { deleteFromIndexedDB } from '../../utils/hooks/useIndexedDB';
import { withRouter } from '../../utils/hoc/withRouter';
import { Tag } from 'antd';
import OptionsDropdown from '../../utils/commonComponent/OptionsDropdown';



class Templates extends Component {
  constructor(props) {
    super(props);
    const AccesData = isModuleExist(MODULE_ID_MAP.ContentMasterTemplate);

    this.state = {
      access: AccesData,
      delete: false,
      deleteData: {},
      editData: "",
      showEdit: false,
      isVerify: false,
      show: false,
      verified: '',
      verifyUrl: '',
      search: ""
    }
  }


  async componentDidMount() {
    const { history } = this.props;
    history({
      pathname: this.props.location.pathname,
      search: `?p=${this.state.currentPage || START_PAGE}`,
    });
    this.props.getAllCustomTemplatesApi(this);
    await deleteFromIndexedDB("canvas", "contentTemplate", "canvas")
  }
  componentDidUpdate(prevProps, prevState) {
    const prevParams = new URLSearchParams(prevProps.location.search);
    const prevPage = parseInt(prevParams.get("page"), 10) || START_PAGE;
    const prevVerified = prevParams.get("isVerified") || "";
    const prevSearch = prevParams.get("search") || "";
    const prevSize = prevParams.get("pageSize") || "";


    const params = new URLSearchParams(this.props.location.search);
    const page = parseInt(params.get("page"), 10) || START_PAGE;
    const search = params.get("search") || "";
    const size = params.get("pageSize") || "";

    const verified = params.get("isVerified") || "";

    if (prevPage !== page || prevSearch !== search || prevVerified !== verified || prevParams.get("search") !== params.get("search") || prevSize !== size) {
      this.setState({ currentPage: page, search }, () => {
        this.props.getAllCustomTemplatesApi(this);

      });
    }
  };
  getDetailsTemplate = (data) => {
    this.props.history({ pathname: `/templates/details/${data?.uuid}`, state: { "data": data } });
  }


  showEditModal = (rowData = null) => {
    this.props.history({ pathname: `/edit-template`,search:"?type=personalization", state: { "data": rowData, "id": rowData.uuid } })
    this.setState({
      showEdit: !this.state.showEdit,
      editData: rowData
    });
  };
  openCloseDeleteModal = (rowData) => {
    this.setState({
      delete: !this.state.delete,
      deleteData: rowData,
    });
  };
  onChangeMethod = (value) => {
    this.setState({ searchText: value.search, currentPage: START_PAGE }, () => {
      replaceHistory(this.props.history, START_PAGE, value.search);
    })
  };
  clearSearch = () => {
    this.onChangeMethod({ search: "" });
  }
  deleteHandle = async (id) => {
    const res = await deleteAuthCommonApi(`/personalizationCustomTemplate/${id}`);
    // console.log(res)
    if (res?.status === 200) {
      this.props.getAllCustomTemplatesApi(this);
      this.setState({
        delete: !this.state.delete
      });

    } else {
      toast.error("Somthis wrong...")
    }
  }

  render() {
    const { access } = this.state;

    const { contentTemplatesList, totalPages, currentPage } = this.props.masterCategoryState;

    return (
      <>

        {this.state.delete && (
          <InformationModal
            show={this.state.delete}
            id={this.state.deleteData?.uuid}
            title={`Are you sure you want to delete ${this.state.deleteData?.templateName} ?`}
            handleClose={this.openCloseDeleteModal}
            handleDelete={this.deleteHandle}
          />
        )}
        <VerifiedModal
          name={`'${this.state.editData?.templateName}'`}
          show={this.state.show}
          url={"personalizationCustomTemplate" + `/${this.state?.editData?.uuid}`}
          isVerified={this.state.isVerify}
          handleCancel={() => { this.setState({ show: false }) }}
          successRes={() => { this.props.getAllCustomTemplatesApi(this) }}
        />
        <section className="request-section">
          <ComponentHeader
            title="Custom Templates"
            isSearch={true}
            breadcrumb={[["Personalization", ""], ["Custom Templates", ""]]}
            placeholder={"Search Template"}
            onChangeMethod={this.onChangeMethod}
            clearSearch={() => this.clearSearch()}
            primaryBtn={access.createAccess ? "Add Template" : ""}
            handlePrimaryBtn={() => {
              this.props.history({ pathname: "/add-template",search:"?type=personalization", state: { contentTemplatesList } });
            }}
            ctx={this}
          />
          <Row>
            <Col sm={2}>
              <FilterVefiedDropDown ctx={this} />
            </Col>
          </Row>
          <div className="commom-table-wrapper">
            <CustomTable
            ctx={this}
              data={contentTemplatesList?.list || []}
              columns={[
                {
                  width: 180,
                  title: "Template Name",
                  dataIndex: "templateName",
                  className: "name",
                  render:(text, rowData, dataKey) => {
                      return rowData?.templateName;
                  },
                },
                {
                  width: access.verificationAccess ? 110 : 0,
                  title: "Verified",
                  dataIndex: "isVerified",
                  className: "verify",
                  isCell: true,
                  render:(text, rowData, dataKey) => {
                     const color = rowData.isVerified ? 'green' : 'orange';
                    return <div className=" d-flex align-items-center inter-medium">
                      <Tag color={color}>{rowData.isVerified ? "YES" : "NO"}
                        <Image src={editPencil} onClick={() => this.setState({ show: true, isVerify: rowData.isVerified, editData: rowData })} className="edit-pencil-icon" alt="icon" />
                      </Tag>
                    </div>;
                  },
                },
                {
                  width: 150,
                  title: "Template Image",
                  dataIndex: "thumbnailImage",
                  className: "logo",
                  isCell: true,
                  render:(text, rowData, dataKey) => {
                      return <Image className="table-img" src={rowData?.thumbnailImage} alt="Thumbnail Image" />;

                  }
                },


                // {
                //   width: 200,
                //   title: "Is Default",
                //   dataIndex: "isDefault",
                //   className: "isDefault",
                //   isCell: true,
                //   render:(text, rowData, dataKey) => {
                //     if (dataKey === "isDefault") {
                //       return rowData?.isDefault ? "Yes" : "No";
                //     }
                //   },
                // },
                {
                  width: 20,
                  title: "Action",
                  dataIndex: "",
                  className: "",
                  fixed:'right',
                  isCell: true,
                  render:(text, rowData, dataKey) => {
                      return (


                        <OptionsDropdown
                          editHandler={access.updateAccess ? () => { this.showEditModal(rowData) } : null}
                          deleteHandler={access.deleteAccess ? () => { this.openCloseDeleteModal(rowData) } : null}
                        />

                      );
                    
                  },
                },
              ]}
              total={contentTemplatesList?.length || 0}
              loading={this.state.isLoading}
            />
          </div>
        </section>
      </>
    )
  }
}

const mapStateToProps = state => ({
  masterCategoryState: state.MasterCategoryState,

});
const mapDispatchToProps = {
  getAllCustomTemplatesApi,
}
Templates.propTypes = {
  // getPosts: PropTypes.func
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Templates));